import React, { useState } from "react";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { useTheme } from "styled-components/native";
import { Pressable, StyleSheet, View } from "react-native";
import { VDBText } from "..";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useGradientFromValue } from "../../../hooks/useThemedGradient";
import { LinearGradient } from "expo-linear-gradient";
import { useSelector } from "react-redux";

type BulkActionsStaticButtonProps = {
  title: string;
  buttonWidth: number;
  buttonTextWidth: number;
  buttonTextHeight: number;
  buttonTextMarginStart: number;
  floatingButtonClick: () => void;
  bottomMargin: number;
  isExpanded: boolean;
};

const BulkActionsStaticButton = ({
  title,
  buttonWidth,
  buttonTextWidth,
  buttonTextHeight,
  buttonTextMarginStart,
  floatingButtonClick,
  isExpanded,
}: BulkActionsStaticButtonProps) => {
  const typography = useTypographyStore();
  const theme = useTheme();
  const [hovered, setHovered] = useState(false);
  const enableGradient = useSelector(
    (state: any) => state.globalData?.app_settings?.enable_gradient
  );
  const currentBgToken = hovered ? "primary-bg-hover" : "primary-bg-static";
  const bgValue = theme[currentBgToken] as string;
  const fallbackColor = theme["core-01"] as string;
  const gradient = useGradientFromValue(bgValue, fallbackColor);

  const handlePress = () => {
    if (floatingButtonClick) {
      floatingButtonClick();
    }
  };

  return (
    <Pressable
      onPress={handlePress}
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
      style={[
        styles.box,
        {
          minWidth: isExpanded ? buttonWidth : 48,
          ...(!enableGradient && {
            backgroundColor: bgValue,
          }),
        },
      ]}
    >
      {enableGradient && (
        <LinearGradient
          colors={gradient.colors as [string, string, ...string[]]}
          start={gradient.start}
          end={gradient.end}
          locations={gradient.locations as [number, number, ...number[]]}
          style={StyleSheet.absoluteFill}
        />
      )}
      {isExpanded && (
        <View
          style={[
            styles.textContainer,
            {
              height: buttonTextHeight,
              width: buttonTextWidth,
              marginStart: buttonTextMarginStart,
            },
          ]}
        >
          <VDBText
            color={theme["primary-cont"]}
            type={typography["Body-M"]}
            style={{ overflow: "hidden" }}
          >
            {title}
          </VDBText>
        </View>
      )}
      <VDBIcon
        color={theme["primary-cont"]}
        size={24}
        variant={IconsVariant.VDBCustom}
        name={"add-circle"}
      />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  box: {
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    borderRadius: 24,
    flexDirection: "row",
    overflow: "hidden",
    gap: 4,
  },
  textContainer: {
    justifyContent: "center",
    alignItems: "flex-start",
  },
});

export default BulkActionsStaticButton;
